// Replace formatDateFromTimestamp with these two functions
export const formatDateForInput = (isoDate) => {
  if (!isoDate) return "";
  try {
      const date = new Date(isoDate);
      if (isNaN(date.getTime())) return "";
      return date.toISOString().split('T')[0]; // YYYY-MM-DD format
  } catch (e) {
      console.error('Date formatting error:', e);
      return "";
  }
};

export const formatDateForBackend = (inputDate) => {
  if (!inputDate) return null;
  try {
      return new Date(inputDate).toISOString();
  } catch (e) {
      console.error('Date conversion error:', e);
      return null;
  }
};